<template>
    <div class="pay-result">
        <div class="success-top">
            <img src="@/assets/images/pay/paySuccess.png" alt="" />
            <div class="text-success">支付成功</div>
            <div class="text-alert">请于付款后尽快离场，以免产生额外费用</div>
        </div>
    </div>
</template>

<script>
import { getPopupActivit, unionPayReturn } from '@/api/apiNoAuth.js'
export default {
    name: "payResult",
    components: {
    },
    data() {
        return {
            showTurntable: false,
            turnData: {}
        };
    },
    mounted() {
        let that = this;
        console.log(this.$route.query);


        this.initGoldPlan()
        unionPayReturn(this.$route.query).then(res => {
            if (res.code == 200) {
                console.log(res);

            }
        })
        // getPopupActivit().then(res => {
        //     if (new Date(res.data.startTime.replace(' ', 'T')).getTime() < new Date().getTime() && new Date(res.data.endTime.replace(' ', 'T')).getTime() > new Date().getTime()) {
        //         this.showTurntable = true;
        //         this.turnData = res.data;

        //     }
        // })
    },
    methods: {
        initGoldPlan() {
            //初始化小票
            var initData = {
                action: 'onIframeReady',
                displayStyle: 'SHOW_CUSTOM_PAGE'
            }
            var initPostData = JSON.stringify(initData)
            parent.postMessage(initPostData, 'https://payapp.weixin.qq.com')
            console.log("初始化");
        }

    },
};
</script>

<style lang="less" scoped>
.pay-result {
    background-color: #fff;
    width: 100vw;
    height: 600px;

    .success-top {
        width: 750px;
        height: 576px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
            height: 128px;
            width: 128px;
        }
        .text-success {
            margin-top: 50px;
            font-size: 32px;
        }
        .text-alert {
            margin-top: 31px;

            font-size: 28px;
            color: #999;
        }
    }
}
</style>
